import "../../assets/vendors/bootstrap-datepicker/bootstrap-datepicker.min.css";
import "../../assets/vendors/mdi/css/materialdesignicons.min.css";
import "../../assets/vendors/flag-icon-css/css/flag-icon.min.css";
import "../../assets/vendors/css/vendor.bundle.base.css";
import "../../assets/vendors/font-awesome/css/font-awesome.min.css";
import "../../assets/images/favicon.png";
import "../../assets/css/style.css";
import logo from "../../assets/images/le-logo-white.png";
import { useEffect, useState, useRef } from "react";
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net";
import "datatables.net-colreorder";
import "datatables.net-colreorder-dt/css/colReorder.dataTables.css";
import "datatables.net-buttons/js/buttons.colVis.min.mjs";
import "datatables.net-buttons/js/dataTables.buttons.mjs";
import "datatables.net-buttons-dt/js/buttons.dataTables.js";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net-buttons/js/buttons.html5.min.mjs";
import "datatables.net-buttons/js/buttons.print.min.mjs";
import "jszip/dist/jszip.js";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import eventEmitter from "./eventEmitter";

export default function Header() {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BASE_URL;
  const [loginUser, setLoginUser] = useState("");
  const [showDropdown, setShowDropdown] = useState(false); // Track dropdown visibility

  const dropdownRef = useRef(null); // Reference for dropdown content
  const toggleButtonRef = useRef(null); // Reference for toggle button

  useEffect(() => {
    setLoginUser(Cookies.get("username"));
  }, []);

  const handleToggle = () => {
    setShowDropdown(!showDropdown); // Toggle dropdown visibility
  };

  // Handle clicks outside of dropdown or toggle button to close dropdown
  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) && // If click is outside dropdown
      toggleButtonRef.current &&
      !toggleButtonRef.current.contains(event.target) // If click is outside toggle button
    ) {
      setShowDropdown(false); // Close dropdown if clicked outside
    }
  };

  // Attach event listener for clicks outside the toggle button and dropdown
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Clean up listener
    };
  }, []);

  const killSession = async () => {
    try {
      const response = await fetch(`${API_URL}sessionSetting.php`, {
        method: "POST",
        body: JSON.stringify({
          type: "killSession",
        }),
      });
      const data = await response.json();
      console.log(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelect = (selectedOption) => {
    console.log(selectedOption); // Handle option selection (My Account, Logout)
    if (selectedOption === "Logout") {
      killSession();
      Cookies.remove("username");
      sessionStorage.clear();
      navigate("/login");
    }
  };

  const dropdownMenuStyle = {
    position: "absolute",
    backgroundColor: "#fff",
    minWidth: "160px",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
    zIndex: 1,
    borderRadius: "4px",
    padding: "0",
    marginTop: "5px",
    marginLeft: "-13px",
    listStyle: "none",
  };

  const dropdownItemStyle = {
    padding: "8px 16px",
    cursor: "pointer",
    textDecoration: "none",
    display: "flex", // Adjust to align icon and text
    alignItems: "center",
    color: "#000",
    width: "100%",
    border: "none",
    backgroundColor: "transparent",
  };

  const buttonStyle = {
    padding: "8px 16px",
    backgroundColor: "transparent",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
  };

  return (
    <>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <title>Connect Plus</title>

      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a className="navbar-brand brand-logo" href="/">
            <img src={logo} alt="logo" />
          </a>
          <a className="navbar-brand brand-logo-mini" href="index.html">
            <img src={logo} alt="logo" />
          </a>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-stretch">
          <ul className="navbar-nav navbar-nav-right">
            <li className="nav-item nav-profile dropdown">
              <div style={{ position: "relative" }}>
                {/* Toggle Button */}
                <button
                  style={buttonStyle}
                  onClick={handleToggle}
                  ref={toggleButtonRef} // Attach reference to the button
                >
                  {loginUser} <span>&#9662;</span>
                </button>

                {/* Dropdown Menu */}
                {showDropdown && (
                  <ul style={dropdownMenuStyle} ref={dropdownRef}>
                    {" "}
                    {/* Attach reference to the dropdown */}
                    <li>
                      <Link
                        style={dropdownItemStyle}
                        to="/myaccount"
                        onClick={() => handleSelect("My Account")}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f1f1f1")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        <i
                          className="mdi mdi-account-circle"
                          style={{ marginRight: "10px" }}
                        ></i>{" "}
                        {/* My Account Icon */}
                        My Account
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        style={dropdownItemStyle}
                        to="/setting"
                        onClick={() => handleSelect('Setting')}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#f1f1f1')}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = 'transparent')}
                      >
                        <i className="mdi mdi-settings" style={{ marginRight: '10px' }}></i> }
                        Setting
                      </Link>
                    </li> */}
                    <li>
                      <button
                        style={dropdownItemStyle}
                        onClick={() => handleSelect("Logout")}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f1f1f1")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        <i
                          className="mdi mdi-logout"
                          style={{ marginRight: "10px" }}
                        ></i>{" "}
                        {/* Logout Icon */}
                        Logout
                      </button>
                    </li>
                  </ul>
                )}
              </div>
            </li>

            {/* Additional navbar items */}
            <li className="nav-item dropdown">
              <a
                className="nav-link count-indicator dropdown-toggle"
                id="messageDropdown"
                href="/#"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="mdi mdi-email-outline"></i>
                <span className="count-symbol bg-success"></span>
              </a>
              <div
                className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
                aria-labelledby="messageDropdown"
              >
                <h6 className="p-3 mb-0 bg-primary text-white py-4">
                  Messages
                </h6>
                {/* Messages List */}
              </div>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link count-indicator dropdown-toggle"
                id="notificationDropdown"
                href="/#"
                data-toggle="dropdown"
              >
                <i className="mdi mdi-bell-outline"></i>
                <span className="count-symbol bg-danger"></span>
              </a>
              <div
                className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
                aria-labelledby="notificationDropdown"
              >
                <h6 className="p-3 mb-0 bg-primary text-white py-4">
                  Notifications
                </h6>
                {/* Notifications List */}
              </div>
            </li>
          </ul>
          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
            onClick={() => {
              eventEmitter.emit("triggerEvent");
            }}
          >
            <span className="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>
    </>
  );
}
